// SIWS CUSTOM: Graphic Series 002 Bundle picker — graphic-series-picker.js
// Cloned from graphic-series-001-picker.js (2026-08-28) with these changes:
//   1. Add-on variant map is DATA-DRIVEN (data-addon-variants) instead of a
//      hardcoded const, so ONE picker file serves both the Tees and Hoodies
//      products — and Series 003+ needs no JS edit at all.
//   2. Add-on variants are keyed [designs_required][band] where band is
//      'standard' (S-2XL) or 'xlplus' (3XL-5XL). The +$2 upcharge lives in the
//      variant price, so the add-on POST splits into up to two line items.
//      Ports the SIWS_XLPLUS_SIZES pattern from bundle-product.js.
//   3. Youth sizes REMOVED for this run (Michelle, 2026-08-27).
//   4. shirtsPerDesign drives everything (20 tees / 10 hoodies) from data attr.

'use strict';

document.querySelectorAll('[data-gs-thumbs] .siws-gs-thumb')
  .forEach(function (btn) {
    btn.addEventListener('click', function () {
      var hero = document.querySelector('[data-gs-hero]');
      if (hero) hero.src = btn.dataset.src;
    });
  });

(function () {
  var root = document.querySelector('[data-gs-picker]');
  if (!root) return;

  var atcBtn        = document.querySelector('[data-gs-atc]');
  var errorEl       = document.querySelector('[data-gs-error]');
  var summaryEl     = root.querySelector('[data-gs-summary]');
  var counterEl     = root.querySelector('[data-gs-counter]');
  var designGrid    = root.querySelector('[data-gs-design-grid]');
  var variantsEl    = root.querySelector('[data-gs-variants]');
  var addonEl       = root.querySelector('[data-gs-addon]');
  var addonPriceEl  = root.querySelector('[data-gs-addon-price]');
  var addonXlPriceEl = root.querySelector('[data-gs-addon-xl-price]');
  var addonRowsEl   = root.querySelector('[data-gs-addon-rows]');
  var addonAddBtn   = root.querySelector('[data-gs-addon-add]');
  var addonTotalEl  = root.querySelector('[data-gs-addon-total]');
  var heroImg       = document.querySelector('[data-gs-hero]');
  var heroDefaultSrc = heroImg ? heroImg.getAttribute('src') : null;

  // Size bands. Youth removed for Series 002. The 3XL-5XL band carries a
  // +$2 upcharge, priced on its own add-on variant (NOT added in JS, and NOT
  // the store-wide $3.00 Size Upcharge product — that one is unrelated).
  if (!atcBtn) { console.warn('[gs] ATC button not found'); return; }

  var variants, designs, addonVariants;
  try {
    variants      = JSON.parse(root.dataset.variants);
    designs       = JSON.parse(root.dataset.designs);
    addonVariants = JSON.parse(root.dataset.addonVariants || '{}');
  } catch (e) {
    console.error('[gs] failed to parse variants/designs/addonVariants JSON', e);
    return;
  }
  if (!variants.length || !designs.length) return;

  var productId        = parseInt(root.dataset.productId, 10);
  var shirtsPerDesign  = parseInt(root.dataset.shirtsPerDesign, 10) || 20;
  var sizeMix          = root.dataset.sizeMix || '';
  var seriesLabel      = root.dataset.seriesLabel || 'Graphic Series 002';
  var addonTitle       = root.dataset.addonProductTitle || '';
  var xlUpcharge       = parseFloat(root.dataset.xlUpcharge || '2') || 0;

  var activeVariantId = variants[0].id;
  var designQtys      = {};
  var cachedCartItems = [];

  function csv(v, fallback) {
    var raw = (v || '').trim();
    if (!raw) return fallback || [];
    return raw.split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  }

  var SIWS_STANDARD_SIZES = csv(root.dataset.standardSizes, ['S', 'M', 'L', 'XL', '2XL']);
  var SIWS_XLPLUS_SIZES   = csv(root.dataset.xlplusSizes,   ['3XL', '4XL', '5XL']);
  var YOUTH_SIZES         = csv(root.dataset.youthSizes,    []);
  var ADULT_SIZES = SIWS_STANDARD_SIZES.concat(SIWS_XLPLUS_SIZES);

  // A series only has size bands if the active tier actually has a separate
  // xlplus add-on variant. Series 001 has one add-on variant per tier and no
  // upcharge, so bandsActive() is false there and everything posts as standard.
  function bandsActive() {
    var tier = addonVariants[String(designsRequired())];
    return !!(tier && tier.xlplus) && SIWS_XLPLUS_SIZES.length > 0;
  }

  function bandForSize(sizeKey) {
    if (!bandsActive()) return 'standard';
    var bare = String(sizeKey).replace(/^Adult\s+/, '');
    return SIWS_XLPLUS_SIZES.indexOf(bare) !== -1 ? 'xlplus' : 'standard';
  }


  var variantsById = variants.reduce(function (acc, v) { acc[v.id] = v; return acc; }, {});
  var designsById  = designs.reduce(function (acc, d) { acc[d.id] = d; return acc; }, {});

  // ─────────── HELPERS ───────────

  function activeVariant()   { return variantsById[activeVariantId]; }
  function designsRequired() { return activeVariant().designs_required; }
  function perShirtPrice()   { return activeVariant().per_shirt_price; }
  function xlPerShirtPrice() { return Number(perShirtPrice()) + (bandsActive() ? xlUpcharge : 0); }

  function addonVariantFor(designsReq, band) {
    var tier = addonVariants[String(designsReq)];
    if (!tier) return null;
    if (band === 'xlplus') return tier.xlplus || tier.standard || null;
    return tier.standard || null;
  }

  function totalAllocated() {
    return Object.keys(designQtys).reduce(function (s, k) { return s + (designQtys[k] || 0); }, 0);
  }
  function totalAddon() {
    var sum = 0;
    if (!addonRowsEl) return 0;
    addonRowsEl.querySelectorAll('.siws-gs-addon-row').forEach(function (row) {
      if (!row.querySelector('.siws-gs-addon-design').value) return;
      var sizes = getRowSizes(row);
      Object.keys(sizes).forEach(function (k) { sum += sizes[k]; });
    });
    return sum;
  }
  function totalAddonByBand() {
    var out = { standard: 0, xlplus: 0 };
    if (!addonRowsEl) return out;
    addonRowsEl.querySelectorAll('.siws-gs-addon-row').forEach(function (row) {
      if (!row.querySelector('.siws-gs-addon-design').value) return;
      var sizes = getRowSizes(row);
      Object.keys(sizes).forEach(function (k) { out[bandForSize(k)] += sizes[k]; });
    });
    return out;
  }
  function formatMoney(cents)     { return '$' + (cents / 100).toFixed(2); }
  function formatDollars(dollars) { return '$' + Number(dollars).toFixed(2); }

  // ─────────── RENDER: design cards ───────────

  function renderDesignCards() {
    designGrid.innerHTML = '';
    designs.forEach(function (d) {
      var card = document.createElement('div');
      card.className = 'siws-gs-design-card';
      card.dataset.designId = d.id;
      card.setAttribute('role', 'listitem');

      if (d.image) {
        var img = document.createElement('img');
        img.className = 'siws-gs-design-card__img';
        img.src       = d.image;
        img.alt       = d.name;
        img.width     = 400;
        img.height    = 400;
        img.loading   = 'eager';
        img.addEventListener('error', function () {
          var ph = document.createElement('div');
          ph.className   = 'siws-gs-design-card__placeholder';
          ph.textContent = d.name;
          if (img.parentNode) img.parentNode.replaceChild(ph, img);
        });
        card.appendChild(img);
      } else {
        var placeholder = document.createElement('div');
        placeholder.className   = 'siws-gs-design-card__placeholder';
        placeholder.textContent = d.name;
        card.appendChild(placeholder);
      }

      var name = document.createElement('span');
      name.className   = 'siws-gs-design-card__name';
      name.textContent = d.name;
      card.appendChild(name);

      var stepper = document.createElement('div');
      stepper.className = 'siws-gs-design-card__stepper';

      var minusBtn = document.createElement('button');
      minusBtn.type = 'button';
      minusBtn.className = 'siws-gs-design-card__step-btn siws-gs-design-card__step-btn--minus';
      minusBtn.setAttribute('aria-label', 'Decrease ' + d.name + ' designs');
      minusBtn.textContent = '−';

      var qtyEl = document.createElement('span');
      qtyEl.className = 'siws-gs-design-card__qty';
      qtyEl.setAttribute('aria-live', 'polite');
      qtyEl.textContent = '0';

      var plusBtn = document.createElement('button');
      plusBtn.type = 'button';
      plusBtn.className = 'siws-gs-design-card__step-btn siws-gs-design-card__step-btn--plus';
      plusBtn.setAttribute('aria-label', 'Increase ' + d.name + ' designs');
      plusBtn.textContent = '+';

      minusBtn.addEventListener('click', function () { stepDesign(d.id, -1); });
      plusBtn.addEventListener('click',  function () { stepDesign(d.id, +1); });

      stepper.appendChild(minusBtn);
      stepper.appendChild(qtyEl);
      stepper.appendChild(plusBtn);
      card.appendChild(stepper);

      designGrid.appendChild(card);
    });
  }

  function stepDesign(designId, delta) {
    var cur = designQtys[designId] || 0;
    var next = cur + delta;
    if (next < 0) return;
    if (delta > 0 && totalAllocated() >= designsRequired()) return;
    if (next === 0) delete designQtys[designId];
    else designQtys[designId] = next;
    syncUI();
  }

  // ─────────── SYNC / RENDER ───────────

  function syncUI() {
    updateCounter();
    updateCardStates();
    updateStepperDisabled();
    updateAddonBlock();
    renderSummary();
    updateAtcButton();
    updateHeroImage();
  }

  function updateCounter() {
    counterEl.textContent = totalAllocated() + ' of ' + designsRequired() + ' designs allocated';
  }

  function updateCardStates() {
    designGrid.querySelectorAll('.siws-gs-design-card').forEach(function (card) {
      var did = parseInt(card.dataset.designId, 10);
      var qty = designQtys[did] || 0;
      card.classList.toggle('siws-gs-design-card--selected', qty > 0);
      var qtyEl = card.querySelector('.siws-gs-design-card__qty');
      if (qtyEl) qtyEl.textContent = String(qty);
    });
  }

  function updateStepperDisabled() {
    var atCap = totalAllocated() >= designsRequired();
    designGrid.querySelectorAll('.siws-gs-design-card').forEach(function (card) {
      var did = parseInt(card.dataset.designId, 10);
      var qty = designQtys[did] || 0;
      var minusBtn = card.querySelector('.siws-gs-design-card__step-btn--minus');
      var plusBtn  = card.querySelector('.siws-gs-design-card__step-btn--plus');
      if (minusBtn) minusBtn.disabled = (qty <= 0);
      if (plusBtn)  plusBtn.disabled  = atCap;
    });
  }

  var _addonBlockLastComplete = false;
  function updateAddonBlock() {
    if (!addonEl) return;
    var complete = totalAllocated() === designsRequired() && totalAllocated() > 0;
    addonEl.hidden = !complete;
    if (addonPriceEl)   addonPriceEl.textContent   = Number(perShirtPrice()).toFixed(2);
    if (addonXlPriceEl) addonXlPriceEl.textContent = Number(xlPerShirtPrice()).toFixed(2);
    var xlNote = root.querySelector('.siws-gs-xl-note');
    if (xlNote) xlNote.hidden = !bandsActive();
    rebuildAddonSelects();
    if (complete && !_addonBlockLastComplete && addonRowsEl && addonRowsEl.children.length === 0) {
      addAddonRow();
    }
    _addonBlockLastComplete = complete;
  }

  function updateHeroImage() {
    if (!heroImg) return;
    var lastId = null;
    Object.keys(designQtys).forEach(function (k) {
      if (designQtys[k] > 0) lastId = parseInt(k, 10);
    });
    if (lastId !== null) {
      var d = designsById[lastId];
      if (d && d.image) heroImg.src = d.image;
    } else if (heroDefaultSrc) {
      heroImg.src = heroDefaultSrc;
    }
  }

  function renderSummary() {
    var entries = Object.keys(designQtys)
      .map(function (k) { return { id: parseInt(k, 10), qty: designQtys[k] }; })
      .filter(function (e) { return e.qty > 0; });

    var header = '<h4 class="siws-gs-summary__title">Adding to Cart</h4>';
    var body;

    if (entries.length === 0) {
      body = '<p class="siws-gs-summary__empty">Allocate ' + designsRequired() +
             ' designs to see your order.</p>';
    } else {
      var psp = perShirtPrice();
      var totalShirts = 0;
      var grandDollars = 0;
      var rowsHtml = entries.map(function (e) {
        var d = designsById[e.id];
        var shirts = e.qty * shirtsPerDesign;
        var lineDollars = shirts * psp;
        totalShirts += shirts;
        grandDollars += lineDollars;
        return '<tr>' +
          '<td>' + (d ? d.name : 'Design ' + e.id) + (e.qty > 1 ? ' (×' + e.qty + ')' : '') + '</td>' +
          '<td class="siws-gs-summary__total">' +
            shirts + ' &times; ' + formatDollars(psp) + ' = ' + formatDollars(lineDollars) +
          '</td>' +
        '</tr>';
      }).join('');

      var addonRowsHtml = '';
      var bands = totalAddonByBand();
      if (bands.standard > 0) {
        var stdDollars = bands.standard * psp;
        grandDollars += stdDollars;
        addonRowsHtml += '<tr>' +
          '<td>Add-On Singles (S–2XL)</td>' +
          '<td class="siws-gs-summary__total">' +
            bands.standard + ' &times; ' + formatDollars(psp) + ' = ' + formatDollars(stdDollars) +
          '</td>' +
        '</tr>';
      }
      if (bands.xlplus > 0) {
        var xlPrice = xlPerShirtPrice();
        var xlDollars = bands.xlplus * xlPrice;
        grandDollars += xlDollars;
        addonRowsHtml += '<tr>' +
          '<td>Add-On Singles (3XL–5XL)</td>' +
          '<td class="siws-gs-summary__total">' +
            bands.xlplus + ' &times; ' + formatDollars(xlPrice) + ' = ' + formatDollars(xlDollars) +
          '</td>' +
        '</tr>';
      }

      var addonSum = bands.standard + bands.xlplus;

      body = '<table class="siws-gs-summary__table">' +
        '<tbody>' + rowsHtml + addonRowsHtml + '</tbody>' +
        '<tfoot>' +
          '<tr><td>Total pieces</td><td class="siws-gs-summary__total">' + (totalShirts + addonSum) + '</td></tr>' +
          '<tr class="siws-gs-summary__grand"><td>Total</td>' +
          '<td class="siws-gs-summary__total">' + formatDollars(grandDollars) + '</td></tr>' +
        '</tfoot>' +
      '</table>';
    }

    summaryEl.innerHTML = header + body;
    renderCartBlock(cachedCartItems);
  }

  function updateAtcButton() {
    var need = designsRequired();
    var alloc = totalAllocated();
    if (alloc < need) {
      var missing = need - alloc;
      atcBtn.disabled    = true;
      atcBtn.textContent = 'Allocate ' + missing + ' more design' + (missing === 1 ? '' : 's') + ' to continue';
    } else if (alloc > need) {
      var over = alloc - need;
      atcBtn.disabled    = true;
      atcBtn.textContent = 'Remove ' + over + ' design' + (over === 1 ? '' : 's');
    } else {
      atcBtn.disabled    = false;
      atcBtn.textContent = 'Add to Cart';
    }
  }

  // ─────────── VARIANT SWITCHING ───────────

  function onVariantChange(e) {
    var target = e.target.closest('[data-gs-variant-radio]');
    if (!target || !target.checked) return;
    var newId = parseInt(target.value, 10);
    if (newId === activeVariantId) return;
    activeVariantId = newId;
    var need = designsRequired();
    while (totalAllocated() > need) {
      var keys = Object.keys(designQtys);
      if (!keys.length) break;
      var lastKey = keys[keys.length - 1];
      designQtys[lastKey] -= 1;
      if (designQtys[lastKey] <= 0) delete designQtys[lastKey];
    }
    syncUI();
  }

  variantsEl.addEventListener('change', onVariantChange);

  // ─────────── ADD-ON ROWS ───────────

  function selectedDesignOptions() {
    return Object.keys(designQtys)
      .map(function (k) { return { id: parseInt(k, 10), qty: designQtys[k] }; })
      .filter(function (o) { return o.qty > 0; })
      .map(function (o) {
        var d = designsById[o.id];
        return { id: o.id, qty: o.qty, name: d ? d.name : ('Design ' + o.id) };
      })
      .sort(function (a, b) { return a.id - b.id; });
  }

  function usedAddonDesignIds(excludeRow) {
    var used = {};
    if (!addonRowsEl) return used;
    addonRowsEl.querySelectorAll('.siws-gs-addon-row').forEach(function (row) {
      if (row === excludeRow) return;
      var val = row.querySelector('.siws-gs-addon-design').value;
      if (val) used[val] = true;
    });
    return used;
  }

  function getRowSizes(row) {
    var out = {};
    row.querySelectorAll('.siws-gs-addon-size-input').forEach(function (inp) {
      var q = Math.max(0, parseInt(inp.value, 10) || 0);
      if (q > 0) out[inp.dataset.sizeKey] = q;
    });
    return out;
  }

  function rebuildAddonSelects() {
    if (!addonRowsEl) return;
    var opts = selectedDesignOptions();
    addonRowsEl.querySelectorAll('.siws-gs-addon-row').forEach(function (row) {
      var select = row.querySelector('.siws-gs-addon-design');
      if (!select) return;
      var currentVal = select.value;
      var usedElsewhere = usedAddonDesignIds(row);
      select.innerHTML = '';
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Choose design…';
      select.appendChild(placeholder);
      opts.forEach(function (o) {
        if (usedElsewhere[String(o.id)] && String(o.id) !== currentVal) return;
        var opt = document.createElement('option');
        opt.value = String(o.id);
        opt.textContent = o.name;
        select.appendChild(opt);
      });
      var keep = currentVal !== '' && opts.some(function (o) { return String(o.id) === currentVal; });
      select.value = keep ? currentVal : '';
      applyRowDisabledState(row);
    });
    updateAddonTotal();
    updateAddonAddBtn();
  }

  function applyRowDisabledState(row) {
    var hasDesign = !!row.querySelector('.siws-gs-addon-design').value;
    row.querySelectorAll('.siws-gs-addon-size-input').forEach(function (inp) {
      inp.disabled = !hasDesign;
      if (!hasDesign) inp.value = '0';
    });
  }

  function buildSizeCell(sizeLabel, sizeKey) {
    var cell = document.createElement('div');
    cell.className = 'siws-gs-addon-size-cell';
    if (bandForSize(sizeKey) === 'xlplus') {
      cell.classList.add('siws-gs-addon-size-cell--xlplus');
    }

    var lbl = document.createElement('span');
    lbl.className = 'siws-gs-addon-size-label';
    lbl.textContent = sizeLabel;
    cell.appendChild(lbl);

    var input = document.createElement('input');
    input.type = 'number';
    input.min = '0';
    input.value = '0';
    input.className = 'siws-gs-addon-size-input';
    input.dataset.sizeKey = sizeKey;
    input.setAttribute('aria-label', sizeKey + ' quantity');
    input.disabled = true;
    cell.appendChild(input);

    return cell;
  }

  function addAddonRow() {
    if (!addonRowsEl) return;

    var row = document.createElement('div');
    row.className = 'siws-gs-addon-row';
    row.setAttribute('role', 'listitem');

    var select = document.createElement('select');
    select.className = 'siws-gs-addon-design';
    select.setAttribute('aria-label', 'Design for add-on piece');
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = totalAllocated() > 0 ? 'Choose design…' : 'Allocate designs first';
    select.appendChild(placeholder);
    var used = usedAddonDesignIds();
    selectedDesignOptions().forEach(function (o) {
      if (used[String(o.id)]) return;
      var opt = document.createElement('option');
      opt.value = String(o.id);
      opt.textContent = o.name;
      select.appendChild(opt);
    });

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'siws-gs-addon-remove';
    removeBtn.setAttribute('aria-label', 'Remove this add-on');
    removeBtn.textContent = '×';
    removeBtn.addEventListener('click', function () {
      row.remove();
      rebuildAddonSelects();
      renderSummary();
    });

    var header = document.createElement('div');
    header.className = 'siws-gs-addon-row-header';
    header.appendChild(select);
    header.appendChild(removeBtn);

    // Youth row is built only if this series defines youth sizes (002 does not).
    // Appended below, AFTER the adult grid, to match the 001 running order.
    var youthLabel = null, youthGrid = null;
    if (YOUTH_SIZES.length) {
      youthLabel = document.createElement('p');
      youthLabel.className = 'siws-gs-addon-sizes-label';
      youthLabel.textContent = 'Youth:';
      youthGrid = document.createElement('div');
      youthGrid.className = 'siws-gs-addon-sizes';
      YOUTH_SIZES.forEach(function (sz) {
        youthGrid.appendChild(buildSizeCell(sz, 'Youth ' + sz));
      });
    }

    var adultLabel = document.createElement('p');
    adultLabel.className = 'siws-gs-addon-sizes-label';
    adultLabel.textContent = 'Adult:';
    var adultGrid = document.createElement('div');
    adultGrid.className = 'siws-gs-addon-sizes';
    ADULT_SIZES.forEach(function (sz) {
      adultGrid.appendChild(buildSizeCell(sz, 'Adult ' + sz));
    });

    var rowTotal = document.createElement('p');
    rowTotal.className = 'siws-gs-addon-row-total';
    rowTotal.hidden = true;

    row.appendChild(header);
    row.appendChild(adultLabel);
    row.appendChild(adultGrid);
    if (youthLabel && youthGrid) {
      row.appendChild(youthLabel);
      row.appendChild(youthGrid);
    }
    row.appendChild(rowTotal);
    addonRowsEl.appendChild(row);

    select.addEventListener('change', function () {
      applyRowDisabledState(row);
      updateRowTotal(row);
      updateAddonTotal();
      rebuildAddonSelects();
      renderSummary();
    });

    row.addEventListener('input', function (e) {
      if (!e.target.classList.contains('siws-gs-addon-size-input')) return;
      var raw = parseFloat(e.target.value);
      e.target.value = isNaN(raw) ? '0' : String(Math.max(0, Math.floor(raw)));
      updateRowTotal(row);
      updateAddonTotal();
      renderSummary();
    });

    updateAddonTotal();
    updateAddonAddBtn();
  }

  function updateAddonAddBtn() {
    if (!addonAddBtn) return;
    var designsWithRows = {};
    addonRowsEl.querySelectorAll('.siws-gs-addon-row').forEach(function (row) {
      var val = row.querySelector('.siws-gs-addon-design').value;
      if (val) designsWithRows[val] = true;
    });
    var allocatedCount = selectedDesignOptions().length;
    var covered = Object.keys(designsWithRows).length;
    addonAddBtn.hidden = allocatedCount > 0 && covered >= allocatedCount;
  }

  function rowBandTotals(row) {
    var sizes = getRowSizes(row);
    var out = { standard: 0, xlplus: 0 };
    Object.keys(sizes).forEach(function (k) { out[bandForSize(k)] += sizes[k]; });
    return out;
  }

  function updateRowTotal(row) {
    var el = row.querySelector('.siws-gs-addon-row-total');
    if (!el) return;
    var b = rowBandTotals(row);
    if (b.standard === 0 && b.xlplus === 0) { el.hidden = true; return; }
    var parts = [];
    if (b.standard > 0) {
      parts.push(b.standard + ' × ' + formatDollars(perShirtPrice()) +
                 ' = ' + formatDollars(b.standard * perShirtPrice()));
    }
    if (b.xlplus > 0) {
      parts.push(b.xlplus + ' × ' + formatDollars(xlPerShirtPrice()) +
                 ' (3XL–5XL) = ' + formatDollars(b.xlplus * xlPerShirtPrice()));
    }
    el.textContent = parts.join('  ·  ');
    el.hidden = false;
  }

  function updateAddonTotal() {
    if (!addonTotalEl) return;
    var b = totalAddonByBand();
    if (b.standard === 0 && b.xlplus === 0) { addonTotalEl.hidden = true; return; }
    var grand = (b.standard * perShirtPrice()) + (b.xlplus * xlPerShirtPrice());
    var count = b.standard + b.xlplus;
    addonTotalEl.textContent = count + ' extra piece' + (count !== 1 ? 's' : '') +
      ' = ' + formatDollars(grand);
    addonTotalEl.hidden = false;
  }

  // Cart line-item data, split by size band so each band posts against its own
  // add-on variant (that's where the +$2 lives).
  function getAddonLineItemsData() {
    var out = [];
    if (!addonRowsEl) return out;
    addonRowsEl.querySelectorAll('.siws-gs-addon-row').forEach(function (row) {
      var designVal = row.querySelector('.siws-gs-addon-design').value;
      if (!designVal) return;
      var designId = parseInt(designVal, 10);
      var d = designsById[designId];
      var sizes = getRowSizes(row);
      var byBand = { standard: {}, xlplus: {} };
      var counts = { standard: 0, xlplus: 0 };
      Object.keys(sizes).forEach(function (k) {
        var band = bandForSize(k);
        byBand[band][k] = sizes[k];
        counts[band] += sizes[k];
      });
      ['standard', 'xlplus'].forEach(function (band) {
        if (counts[band] === 0) return;
        var props = { 'Design': d ? d.name : ('Design ' + designId) };
        if (d && d.sku) props['Part #'] = d.sku;
        Object.keys(byBand[band]).forEach(function (k) { props[k] = String(byBand[band][k]); });
        props['Total pieces'] = String(counts[band]);
        out.push({ designId: designId, band: band, qty: counts[band], properties: props });
      });
    });
    return out;
  }

  if (addonAddBtn) {
    addonAddBtn.addEventListener('click', function () { addAddonRow(); });
  }

  function clearAddons() {
    if (addonRowsEl) addonRowsEl.innerHTML = '';
    if (addonTotalEl) { addonTotalEl.hidden = true; addonTotalEl.textContent = ''; }
  }

  // ─────────── CART HYDRATION ───────────

  function isAddonItem(i) {
    return !!addonTitle && i.product_title === addonTitle;
  }

  function renderCartBlock(items) {
    if (!summaryEl) return;
    var existing = summaryEl.querySelector('.siws-gs-cart-block');
    if (!items || items.length === 0) {
      if (existing) existing.remove();
      return;
    }
    var subtotal = items.reduce(function (s, i) {
      return s + (i.final_line_price || i.line_price || 0);
    }, 0);
    var linesHtml = items.map(function (i) {
      var unit = i.final_price || i.price || 0;
      var line = i.final_line_price || i.line_price || 0;
      var label;
      if (isAddonItem(i)) {
        // Lead with the DESIGN NAME so two designs' add-ons are tellable apart;
        // fall back to the aggregate size string only when no design key exists.
        var props = i.properties || {};
        var designKeys = Object.keys(props).filter(function (k) {
          return k.indexOf('Add-On:') === 0;
        });
        if (designKeys.length) {
          label = designKeys.map(function (k) {
            var design = k.replace(/^Add-On:\s*/, '');
            return design + (props[k] ? ' — ' + props[k] : '');
          }).join('; ');
          label = 'Add-On: ' + label;
        } else {
          var summary = props['Size mix'] || '';
          label = 'Add-On' + (summary ? ': ' + summary : '');
        }
      } else {
        label = i.variant_title || i.title;
      }
      return '<tr>' +
        '<td>' + label + '</td>' +
        '<td class="siws-gs-summary__total">' +
          i.quantity + ' &times; ' + formatMoney(unit) + ' = ' + formatMoney(line) +
        '</td>' +
      '</tr>';
    }).join('');
    var blockHtml =
      '<div class="siws-gs-cart-block">' +
        '<h3 class="siws-gs-cart-block__heading">Already in Your Cart</h3>' +
        '<table class="siws-gs-summary__table">' +
          '<tbody>' + linesHtml + '</tbody>' +
          '<tfoot>' +
            '<tr class="siws-gs-summary__grand">' +
              '<td>Subtotal</td>' +
              '<td class="siws-gs-summary__total">' + formatMoney(subtotal) + '</td>' +
            '</tr>' +
          '</tfoot>' +
        '</table>' +
      '</div>';
    if (existing) existing.outerHTML = blockHtml;
    else summaryEl.insertAdjacentHTML('afterbegin', blockHtml);
  }

  function hydrateCart() {
    fetch('/cart.js')
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (cart) {
        cachedCartItems = (cart.items || []).filter(function (i) {
          return i.product_id === productId || isAddonItem(i);
        });
        renderCartBlock(cachedCartItems);
      })
      .catch(function () { cachedCartItems = []; });
  }

  // ─────────── ATC HANDLER ───────────

  function buildDesignsProperty() {
    return Object.keys(designQtys)
      .map(function (k) {
        var d = designsById[parseInt(k, 10)];
        var qty = designQtys[k];
        var name = d ? d.name : ('Design ' + k);
        return qty > 1 ? name + ' (×' + qty + ')' : name;
      })
      .join(', ');
  }

  function buildPartNumbersProperty() {
    return Object.keys(designQtys)
      .map(function (k) {
        var d = designsById[parseInt(k, 10)];
        return d && d.sku ? d.sku : null;
      })
      .filter(Boolean)
      .join(', ');
  }

  atcBtn.addEventListener('click', function () {
    if (atcBtn.disabled) return;
    var v = activeVariant();
    if (!v) return;
    var alloc = totalAllocated();
    if (alloc !== v.designs_required) return;

    var totalShirts = alloc * shirtsPerDesign;
    var bundleProps = {
      'Bundle':            seriesLabel + ' — ' + v.title,
      'Designs':           buildDesignsProperty(),
      '_Part #s':          buildPartNumbersProperty(),
      // Hidden pairing key. cart.js uses this to detect orphaned add-on lines
      // when the bundle is deleted — add-ons cannot be ordered on their own.
      '_Add-on product':   addonTitle,
      'Pieces per design': String(shirtsPerDesign),
      'Size mix':          sizeMix,
      'Total pieces':      String(totalShirts),
      'Per piece price':   formatDollars(v.per_shirt_price)
    };

    var items = [{ id: v.id, quantity: 1, properties: bundleProps }];

    var cartUI = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var sectionsToRender = cartUI ? cartUI.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-icon-bubble'];
    var body = {
      items: items,
      sections:     sectionsToRender,
      sections_url: window.location.pathname
    };

    // Add-on payload — one line per size band, each against its own variant.
    var addonData = getAddonLineItemsData();
    var dr        = v.designs_required;
    var byBand    = { standard: [], xlplus: [] };
    addonData.forEach(function (a) { byBand[a.band].push(a); });

    var addonItems = [];
    ['standard', 'xlplus'].forEach(function (band) {
      var rows = byBand[band];
      if (!rows.length) return;
      var variantId = addonVariantFor(dr, band);
      if (!variantId) {
        console.warn('[gs] no add-on variant for designs_required=' + dr + ' band=' + band);
        return;
      }
      var qty = rows.reduce(function (s, a) { return s + a.qty; }, 0);
      if (qty === 0) return;
      var addonProps = {};
      var sizeAgg = {};
      var addonSkus = [];
      rows.forEach(function (a) {
        var d = designsById[a.designId];
        var name = d ? d.name : ('Design ' + a.designId);
        var pairs = [];
        Object.keys(a.properties).forEach(function (k) {
          if (k === 'Design' || k === 'Total pieces' || k === 'Bundle' || k === 'Part #') return;
          var q = parseInt(a.properties[k], 10) || 0;
          sizeAgg[k] = (sizeAgg[k] || 0) + q;
          pairs.push(k + ': ' + a.properties[k]);
        });
        // Part number stays OUT of the visible label — dealers should not see
        // SKUs in cart or checkout. It rides on the hidden _Part #s key below,
        // which Shopify omits from storefront display but keeps on the order.
        addonProps['Add-On: ' + name] = pairs.join(', ');
        if (d && d.sku) addonSkus.push(d.sku);
      });
      if (addonSkus.length) addonProps['_Part #s'] = addonSkus.join(', ');
      addonProps['Size band'] = (band === 'xlplus') ? '3XL-5XL' : 'S-2XL';
      addonProps['Size mix'] = Object.keys(sizeAgg)
        .map(function (k) { return k + ': ' + sizeAgg[k]; })
        .join(', ');
      addonItems.push({ id: variantId, quantity: qty, properties: addonProps });
    });

    var addonBody = addonItems.length
      ? { items: addonItems, sections: sectionsToRender, sections_url: window.location.pathname }
      : null;

    atcBtn.disabled = true;
    var originalText = atcBtn.textContent;
    atcBtn.textContent = 'Adding…';
    errorEl.hidden = true;

    // ADDON → BUNDLE order so the bundle is newest and renders above the
    // add-on lines in the cart (same rationale as GS001).
    var addonPromise = addonBody
      ? fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify(addonBody)
        }).then(async function (res) {
          if (!res.ok) {
            var addonErr = await res.json().catch(function () { return {}; });
            console.warn('[gs] addon POST failed:', addonErr.description || 'unknown');
            return null;
          }
          return await res.json();
        })
      : Promise.resolve(null);

    addonPromise
      .then(function () {
        return fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify(body)
        });
      })
      .then(async function (res) {
        if (!res.ok) {
          var e = await res.json().catch(function () { return {}; });
          throw new Error(e.description || 'Cart add failed');
        }
        return await res.json();
      })
      .then(function (responseData) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'siws-gs', cartData: responseData });
        }
        if (cartUI) {
          cartUI.renderContents(responseData);
        } else {
          var newBubbleHTML = responseData.sections && responseData.sections['cart-icon-bubble'];
          var liveBubble = document.getElementById('cart-icon-bubble');
          if (newBubbleHTML && liveBubble) {
            var parsed = new DOMParser().parseFromString(newBubbleHTML, 'text/html');
            var inner = parsed.querySelector('.shopify-section');
            if (inner) liveBubble.innerHTML = inner.innerHTML;
          }
        }
        for (var k in designQtys) delete designQtys[k];
        clearAddons();
        syncUI();
        hydrateCart();
      })
      .catch(function (err) {
        atcBtn.disabled    = false;
        atcBtn.textContent = originalText;
        errorEl.textContent = (err && err.message) ? err.message : 'Something went wrong — please try again.';
        errorEl.hidden = false;
      });
  });

  // ─────────── INIT ───────────

  renderDesignCards();
  syncUI();
  hydrateCart();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { hydrateCart(); });
  }
})();
